const initHotelRoomsOptionsManager = ()=>{
    const hotelRoomsCollections = {};
    return {
        getHotelRoomsByRateId: (rateId)=>hotelRoomsCollections[rateId],
        setHotelRooms: (chatMessagesList)=>{
            const hotelRoomsOptionsMarkers = chatMessagesList.filter((m)=>m?.displayComponentName === 'HOTEL_ROOM_DETAIL_CARD' && m?.markerComponentProps);
            hotelRoomsOptionsMarkers?.forEach(({ markerComponentProps })=>{
                const { rooms, searchInfo, hotelName, hotelId, checkIn, checkOut } = markerComponentProps;
                rooms?.forEach((room)=>{
                    room?.rates?.forEach((rate)=>{
                        if (rate?.rateId) hotelRoomsCollections[rate.rateId] = {
                            ...rate,
                            itemKey: searchInfo?.itemKey,
                            hotelName,
                            hotelId,
                            checkIn,
                            checkOut
                        };
                    });
                });
            });
        }
    };
};
const hotelRoomsOptionsManager = initHotelRoomsOptionsManager();
export { hotelRoomsOptionsManager, initHotelRoomsOptionsManager };
